import { useQuery } from '@tanstack/react-query';
import { useParams } from 'react-router-dom';

import { useProfile } from '../profile';

import { sdk } from '@/services';

const LiveClassVoteService = sdk.getService('LiveClassVoteService');

export const useLiveClassVote = () => {
  const { _id } = useParams<{ _id: string }>();
  const {
    roleCheck: { isStudent }
  } = useProfile();

  const { isLoading, data, error } = useQuery({
    queryKey: ['events', 'live-class-vote', _id],
    queryFn: () => LiveClassVoteService.findEventVote(_id!),
    enabled: !!_id && isStudent,
    staleTime: Infinity
  });

  return {
    liveClassVote: data,
    isLoading,
    error
  };
};
